import { SidebarOverlay } from './SidebarOverlay';
import { SidebarIconRail } from './SidebarIconRail';
import { SidebarPanel } from './SidebarPanel';
import { useSidebar } from '@/core/hooks/useSidebar';
import { cn } from '@/core/lib/utils';

export function Sidebar() {
  const { isMobileOpen, isMobile } = useSidebar();

  return (
    <>
      <SidebarOverlay />
      <aside
        className={cn(
          'fixed top-14 left-0 bottom-0 z-40 flex h-[calc(100vh-56px)]',
          'md:relative md:top-0 md:translate-x-0',
          'transition-transform duration-300',
          isMobile && !isMobileOpen ? '-translate-x-full' : 'translate-x-0',
        )}
      >
        <SidebarIconRail />
        <SidebarPanel />
      </aside>
    </>
  );
}
